export const num = (v) => (v === null || v === undefined ? '—' : String(v))

export const markerValue = (v) => (v ? `${v.value_operator ?? ''}${num(v.value)}` : '—')

/** A change as a number, or as a bound when a censored value is involved. */
export const changeText = (m) => {
  if (m.change !== null && m.change !== undefined) return `${m.change > 0 ? '+' : ''}${m.change}`
  if (m.change_bound) return `${m.change_bound.operator} ${m.change_bound.value}`
  return '—'
}
